import {AppActionType, UserState} from './types';

export const APP_SET_USER = 'APP/SET_USER';
export const APP_CLEAR_USER = 'APP/CLEAR_USER';

export function setUser(newUserState: UserState): AppActionType {
  return {
    type: APP_SET_USER,
    payload: {user: newUserState},
  };
}

export function clearUser(): AppActionType {
  return {
    type: APP_CLEAR_USER,
    payload: {},
  };
}
